export const PROVIDERS = [
    'Evolution',
    'Pariplay',
    'Winpot',
    'Zitro',
];
